import { render, staticRenderFns } from "./createjobvacancy.vue?vue&type=template&id=1a18fe28&"
import script from "./createjobvacancy.vue?vue&type=script&lang=js&"
export * from "./createjobvacancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports